import { Link } from '@tanstack/react-router'
import { useLingui } from '@lingui/react/macro'
import { LogoIcon } from '@/routes/_app/-components/shared/logo'
import { useAppStore } from '@/lib/app-store'
import { authViewTransition, cn } from '@/lib/utils'

/** Brand logo linking back to the landing page. Sits at the top of the initial auth pages
 *  (login / register) so visitors can return home. Hidden when an SDK embedder disables the logo. */
export function HomeLink({ className }: { className?: string }) {
  const { t } = useLingui()
  const disableLogo = useAppStore((state) => state.store.customize.disableLogo)

  if (disableLogo) return null

  return (
    <Link
      to="/"
      viewTransition={authViewTransition('exit')}
      title={t`Back to home`}
      aria-label={t`Back to home`}
      className={cn('transition-opacity hover:opacity-70', className)}
    >
      <LogoIcon className="h-auto w-32" />
    </Link>
  )
}
